import { GlobalStore } from "@roc/client-portal-shared/stores";
import { ScopeOfWorkV2FormStore } from "@roc/feature-sow-shared/stores/v2";
import { ScopeOfWorkRevisionFormParams, ScopeOfWorkV2 } from "@roc/feature-sow-shared/types";
import { ScopeOfWorkRevisionFormService, SecureLinkScopeOfWorkRevisionService } from "../services";
import { CALLBACK_TYPE } from "@roc/feature-sow-shared/constants/scopeOfWorkV2Form";
import { SegmentTrackerEvent, segmentAnalytics } from "@roc/feature-utils";

/**
 * The revision form of the secure link page. Its revision calls go through the session (setSecureLinkService, from
 * ScopeOfWorkRevisionStore.setRequest): the revision draw comes from the session on the server. Only the export, which
 * reads nothing stored, uses the public ScopeOfWorkRevisionFormService.
 */
export class ScopeOfWorkRevisionFormStore extends ScopeOfWorkV2FormStore {
  params: ScopeOfWorkRevisionFormParams;
  private secureLinkService: SecureLinkScopeOfWorkRevisionService;

  constructor(globalStore: GlobalStore) {
    super(globalStore);
    this.scopeOfWorkService = new ScopeOfWorkRevisionFormService();
  }

  setSecureLinkService(secureLinkService: SecureLinkScopeOfWorkRevisionService) {
    this.secureLinkService = secureLinkService;
  }

  setParams(params: ScopeOfWorkRevisionFormParams) {
    this.params = params;
    this.fetchInitialData();
  };

  *savePdf(response) {
    this.afterCall(CALLBACK_TYPE.SUBMIT, response);
  }

  splitCategories = async () => {
    return this.secureLinkService.getSplitCategories();
  }

  *handleSplitedCategories() {
    const response = yield this.splitCategories();
    this.splitedCategoriesObj = response;
  }

  *fetchScopeOfWork() {
    try {
      const response: ScopeOfWorkV2 = yield this.getScopeOfWork(this.params);
      const categoriesResponse = yield this.getScopeOfWorkCategories();
      if (!response || !categoriesResponse) return;
      this.initParams(response);
      this.initScopeOfWork(response, categoriesResponse);
      this.handleSplitedCategories()
    } catch (error) {
      console.log({ error })
      this.afterCall(CALLBACK_TYPE.GET, null);
    }
  };

  getScopeOfWork = async (params: ScopeOfWorkRevisionFormParams) => {
    try {
      const sowRevision: any = { ...(await this.secureLinkService.getData()) };
      sowRevision.status = 'Pending';
      sowRevision.dataContent = JSON.parse(sowRevision.dataContent);
      sowRevision.originalData = sowRevision.originalData ? JSON.parse(sowRevision.originalData) : null;
      return sowRevision;
    } catch (error) {
      console.log({ error });
    }
  };

  submitScopeOfWork = async (
    params: ScopeOfWorkRevisionFormParams,
    data: any
  ) => {
    try {
      const response = await this.secureLinkService.submit(data);
      segmentAnalytics.trackEvent({
        name: SegmentTrackerEvent.SOW_REVISION,
        userName: this.userStore?.userInformation?.username,
      });
      return response;
    } catch (error) {
      console.log({ error });
    }
  };

  getScopeOfWorkCategories = async () => {
    return this.secureLinkService.getCategories();
  };

  getSowSubmissionErrors = async (loanId: any, propertyId: any, data: any) => {
    return this.secureLinkService.getSubmissionErrors(data, this.scopeOfWork?.version || 2);
  }

  saveScopeOfWorkAuditLogs = async (scopeOfWorkId: any, lenderId: any, data: any, isSubmit: boolean, userName: string) => {
  }

  reset(): void {
    super.reset();
  };
}
